const ja = {
  10000001: 'SuperEx 2周年記念イベント',
  10000002: 'サインインして豪華な特典を受け取りましょう',
  10000003: '参加者数に応じて賞金総額が増え、最大10,000USDTとなる。',
  10000004: 'SuperEx 2周年記念イベント',
  10000005: '先物取引コンテストで20000USDTを獲得',
  10000006: `最大 <span style="color: #ffc72b;">10,000</span> USDTのボーナスプールをアンロックする先物取引高ランキング大会 `,
  10000007: 'フューチャーズ選手権',
  10000008: '先物取引コンテストで20000USDTを獲得',
}
export default  ja



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/ja.js